let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("foP9G")).then(() => parcelRequire('jew0P'));